import { FC } from "react"
import './spinner.css'

export const Spinner:FC<any> = (props):JSX.Element => {

    const { message } = props
    return(
        <div className="spinner__wrapper">
            <div className="lds-ripple"><div></div><div></div></div>
            <span className="spinner__wrapper-message">{message}</span>
        </div>
        
    )
}